<template>
  <pagefra>
    <div
      class="alarm container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            class="toolbar-form"
            :inline="true"
            v-model="form"
            label-width
          >
            <!-- <el-form-item label="所属区域">
              <areaCascader
                ref="ac"
                :multiple="true"
                :checkStrictly="true"
              ></areaCascader>
            </el-form-item> -->
            <el-form-item :label="$l('所属城市')">
              <el-input
                v-model="form.city"
                :placeholder="$l('所属城市')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('地盘名称')">
              <el-input
                v-model="form.domainName"
                :placeholder="$l('地盘名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('工号')">
              <el-input
                v-model="form.jobNum"
                :placeholder="$l('工号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('大楼名称')">
              <el-input
                v-model="form.buildingName"
                :placeholder="$l('大楼名称')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('注册代码')">
              <el-input
                v-model="form.registerCode"
                :placeholder="$l('注册代码')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('电梯类型')">
              <el-select
                v-model="form.elevatorType"
                :placeholder="$l('电梯类型')"
              >
                <el-option :label="$l('电梯类型')" value></el-option>
                <el-option :label="$l('直梯')" value="直梯"></el-option>
                <el-option :label="$l('扶梯')" value="扶梯"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('处理方式')">
              <el-select
                v-model="form.processType"
                :placeholder="$l('处理方式')"
              >
                <el-option :label="$l('全部报警')" value="-1"></el-option>
                <el-option :label="$l('电梯自恢复')" value="0"></el-option>
                <el-option :label="$l('派工')" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('报警信息')">
              <el-select
                v-model="form.description"
                :placeholder="$l('报警信息')"
                filterable
                clearable
              >
                <el-option
                  :label="$l(item.name)"
                  :value="item.name"
                  v-for="(item, index) in faultDescList"
                  :key="index"
                ></el-option>
                <!-- <el-option label="运行中开门" value="运行中开门"></el-option>
                <el-option label="市电断开" value="市电断开"></el-option>
                <el-option label="检修状态" value="检修状态"></el-option>
                <el-option label="不能起动" value="不能起动"></el-option>
                <el-option
                  label="外召按钮卡死故障"
                  value="外召按钮卡死故障"
                ></el-option>
                <el-option
                  label="内召按钮卡死故障"
                  value="内召按钮卡死故障"
                ></el-option>
                <el-option label="电梯A类故障" value="电梯A类故障"></el-option>
                <el-option label="电梯B类故障" value="电梯B类故障"></el-option>
                <el-option label="电梯C类故障" value="电梯C类故障"></el-option>
                <el-option label="门区外停梯" value="门区外停梯"></el-option>
                <el-option label="停电困人" value="停电困人"></el-option>
                <el-option
                  label="电源系统异常"
                  value="电源系统异常"
                ></el-option>
                <el-option
                  label="安全装置动作"
                  value="安全装置动作"
                ></el-option>
                <el-option label="可能困人" value="可能困人"></el-option>
                <el-option label="开关门异常" value="开关门异常"></el-option>
                <el-option label="肯定困人" value="肯定困人"></el-option>
                <el-option label="遥监检修" value="遥监检修"></el-option>
                <el-option label="不能启动" value="不能启动"></el-option> -->
              </el-select>
            </el-form-item>
            <!-- <el-form-item :label="$l('故障回访')">
              <el-select
                v-model="form.returnStatus"
                :placeholder="$l('故障回访')"
              >
                <el-option :label="$l('故障回访')" value="-1"></el-option>
                <el-option :label="$l('已回访')" value="0"></el-option>
                <el-option :label="$l('未回访')" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item :label="$l('是否困人')">
              <el-select v-model="form.boxUp" :placeholder="$l('是否困人')">
                <el-option :label="$l('是否困人')" value=""></el-option>
                <el-option :label="$l('是')" value="是"></el-option>
                <el-option :label="$l('否')" value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('是否完成')">
              <el-select
                v-model="form.finishStatus"
                :placeholder="$l('是否完成')"
              >
                <el-option :label="$l('是否完成')" value="-1"></el-option>
                <el-option :label="$l('已完成')" value="0"></el-option>
                <el-option :label="$l('未完成')" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$l('报警时间')">
              <el-date-picker
                v-model="alarmTimeRange"
                type="datetimerange"
                unlink-panels
                :range-separator="$l('至')"
                :start-placeholder="$l('开始时间')"
                :end-placeholder="$l('结束时间')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="em"
                circle
                @click="search"
                :disabled="!isSearch"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-edit-outline"
              round
              @click="showSetting()"
              v-show="hasPermission('设置')"
              >{{ $l("设置") }}
            </el-button>
            <el-button
              type="em"
              round
              icon="el-icon-download"
              @click="exportAlarm"
              v-if="hasPermission('导出')"
              >{{ $l("导出") }}
            </el-button>
          </div>
        </div>
      </panel>
      <div class="tagBar" v-if="rowData || statisticType">
        <el-button
          type="white"
          size="small"
          icon="el-icon-back"
          round
          @click="handleCloseTag"
          >{{ $l("返回上级") }}</el-button
        >
        {{ $l("当前选择") }}：
        <!-- <el-tag closable @close="handleCloseTag">{{
          getCurrentSelect()
        }}</el-tag> -->
        {{ getCurrentSelect() }}
      </div>
      <el-row type="flex" :gutter="20" v-if="level == 1">
        <el-col v-for="item in elevatorStatusArr" :key="item.type">
          <!-- <panel type="gray">
            <div class="datacard">
              <h3>{{ $l(item.text) }}</h3>
              <p @click="initChildData(item.type, 1)">{{ item.value }}</p>
            </div>
          </panel> -->
          <attrCard
            :label="$l(item.text)"
            :value="item.value"
            @click.native="initChildData(item.type, 1)"
          ></attrCard>
        </el-col>
      </el-row>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            :data="tableData"
            highlight-current-row
            height="100%"
            style="width: 100%; z-index: 1000"
            v-loading.lock="loading"
            :element-loading-text="$l('加载中')"
            v-if="level == 1"
          >
            <el-table-column
              :label="$l('序号')"
              type="index"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
              :formatter="cityFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <a @click="initChildData(scope.row, 1)">
                  <span class="el-icon-tickets link-icon"></span
                  >{{ scope.row.domainName }}
                </a>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('困人数量')"
              prop="count1"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag">{{ scope.row.count1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('非困人数量')"
              prop="count2"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag numTag--warning">{{
                  scope.row.count2
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('派工记录数量')"
              prop="count3"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag">{{ scope.row.count3 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('预警记录数量')"
              prop="count4"
              align="center"
              min-width="120"
            >
              <template slot-scope="scope">
                <span class="numTag numTag--warning">{{
                  scope.row.count4
                }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            ref="filterTable"
            :data="tableData"
            height="100%"
            style="width: 100%; z-index: 1000"
            :row-style="tableRowStyle"
            v-loading.lock="loading"
            :element-loading-text="$l('加载中')"
            v-else
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('城市')"
              prop="city"
              align="center"
              min-width="120"
              :formatter="cityFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('地盘名称')"
              prop="domainName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('大楼名称')"
              prop="buildingName"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯号')"
              prop="elevatorNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('工号')"
              prop="jobNum"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('梯龄')"
              prop="elevatorAge"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('报警时间')"
              prop="alarmDate"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('报警信息')"
              prop="description"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                <span :title="scope.row.description">{{
                  $l(
                    scope.row.description && scope.row.description.length > 20
                      ? scope.row.description.substring(0, 20) + "..."
                      : scope.row.description
                  )
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('主微机故障码')"
              prop="mainFaultCode"
              align="center"
              min-width="120"
              v-if="hasFieldPermission('主微机故障码') && form.processType == 0"
              key="mainFaultCode"
            ></el-table-column>
            <el-table-column
              :label="$l('变频器故障码')"
              prop="subFaultCode"
              align="center"
              min-width="120"
              v-if="hasFieldPermission('变频器故障码') && form.processType == 0"
              key="subFaultCode"
            ></el-table-column>
            <el-table-column
              :label="$l('是否困人')"
              prop="boxUp"
              align="center"
              min-width="80"
              :formatter="boxUpFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('下单来源')"
              prop="serviceRequestSource"
              align="center"
              min-width="100"
              v-if="form.processType != 0"
              key="serviceRequestSource"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('警报来源')"
              prop="sourceId"
              align="center"
              min-width="100"
              :formatter="sourceFormatter"
            ></el-table-column> -->
            <el-table-column
              :label="$l('处理方式')"
              prop="processType"
              align="center"
              min-width="100"
              :formatter="processWayFormatter"
              v-if="form.processType == -1"
              key="processType"
            ></el-table-column>
            <el-table-column
              :label="$l('派工时间')"
              prop="processDate"
              min-width="120"
              v-if="hasFieldPermission('派工时间') && form.processType != 0"
              key="processDate"
            ></el-table-column>
            <el-table-column
              :label="$l('到场时间')"
              prop="arriveDate"
              min-width="120"
              v-if="hasFieldPermission('到场时间') && form.processType != 0"
              key="arriveDate"
            ></el-table-column>
            <el-table-column
              :label="$l('救援时间')"
              prop="rescueCompleteTime"
              min-width="120"
              v-if="form.processType != 0"
              key="rescueCompleteTime"
              :formatter="rescueCompleteTimeFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('报警解除时间')"
              prop="finishDate"
              min-width="130"
              :formatter="finishDateFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯品牌')"
              prop="brand"
              align="center"
              min-width="150"
              :formatter="elevatorBrandFormatter"
            ></el-table-column>
            <el-table-column
              :label="$l('注册代码')"
              prop="registerCode"
              align="center"
              min-width="150"
            ></el-table-column>
            <el-table-column
              :label="$l('原因分析')"
              prop="reasonAnalyze"
              align="center"
              min-width="100"
              v-if="form.processType != 0"
            >
              <template slot-scope="scope">
                <span :title="scope.row.reasonAnalyze">{{
                  scope.row.reasonAnalyze && scope.row.reasonAnalyze.length > 20
                    ? scope.row.reasonAnalyze.substring(0, 20) + "..."
                    : scope.row.reasonAnalyze
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('解决办法')"
              prop="solveMethod"
              align="center"
              min-width="100"
              v-if="form.processType != 0"
            >
              <template slot-scope="scope">
                <span :title="scope.row.solveMethod">{{
                  scope.row.solveMethod && scope.row.solveMethod.length > 20
                    ? scope.row.solveMethod.substring(0, 20) + "..."
                    : scope.row.solveMethod
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('遥监设备状态')"
              prop="isactive"
              align="center"
              min-width="150"
              :formatter="monitorStatusFormatter"
            ></el-table-column>
            <!-- <el-table-column
              :label="$l('故障回访')"
              prop="returnStatusName"
              align="center"
              min-width="100"
              :formatter="returnCallStatusFormatter"
              v-if="form.processType != 0"
              key="returnStatusName"
            ></el-table-column> -->
            <el-table-column
              :label="$l('困人图片')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermission('困人图片')"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  light
                  circle
                  @click="viewTrappedImage(scope.row)"
                  v-if="scope.row.boxUp == '是' && scope.row.deviceType"
                >
                  <svgicon name="tiring" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('视频回放')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermission('视频回放')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.deviceType == 2"
                  type="primary"
                  light
                  circle
                  @click="playback(scope.row)"
                >
                  <svgicon name="playback" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('实时监视')"
              align="center"
              min-width="100"
              fixed="right"
              v-if="hasPermissionByName('monitor')"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.isactive"
                  type="primary"
                  light
                  circle
                  @click="handleMonitor(scope.$index, scope.row)"
                >
                  <svgicon name="monitor" class></svgicon>
                </el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column
              :label="$l('回访记录')"
              min-width="100"
              show-overflow-tooltip
              header-align="center"
              align="center"
              fixed="right"
              v-if="form.processType != 0"
              key="callRecord"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  light
                  circle
                  icon="el-icon-document"
                  @click="viewReturnCall(scope.$index, scope.row)"
                ></el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>
      <el-dialog
        :title="$l('报警设置')"
        width="400px"
        :visible.sync="settingDialogVisible"
      >
        <el-form
          ref="settingForm"
          :model="settingForm"
          label-width="120px"
          size="small"
          class="dialog-form"
        >
          <el-form-item :label="$l('是否报警弹窗')">
            <el-switch v-model="settingForm.isEnable"></el-switch>
          </el-form-item>
          <el-form-item :label="$l('是否报警播放')">
            <el-switch v-model="settingForm.isEnableSpeak"></el-switch>
          </el-form-item>
          <!-- <el-form-item label="播放条数">
            <el-input-number
              v-model="settingForm.number"
              :min="1"
              :max="10"
              label="播放条数"
            ></el-input-number>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="settingDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="settingAlarm"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('查看客户回访记录')"
        :visible.sync="viewReturnDialogVisible"
      >
        <el-form
          ref="returnForm"
          :model="returnForm"
          :rules="returnFormRules"
          label-width="160px"
          size="medium"
          class="returnForm"
        >
          <el-form-item :label="$l('回访时间')" prop="returnFinishDatetime">
            <el-input
              v-model="returnForm.returnFinishDatetime"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('回访关闭时间')"
            prop="returnComplateDatetime"
          >
            <el-input
              v-model="returnForm.returnComplateDatetime"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('回访说明')" prop="returnDesc">
            <el-input
              v-model="returnForm.returnDesc"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('故障处理是否完成')">
            <el-switch
              v-model="returnForm.isReturnFinish"
              active-color="#13ce66"
              :disabled="!isEditReturn"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="$l('是否完工备注')" prop="finishRemark">
            <el-input
              v-model="returnForm.finishRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('维保工提出其他要求')">
            <el-switch
              v-model="returnForm.unreasonableDemands"
              active-color="#13ce66"
              :disabled="!isEditReturn"
            >
            </el-switch>
          </el-form-item>
          <el-form-item :label="$l('不合理备注')" prop="unreasonableRemark">
            <el-input
              v-model="returnForm.unreasonableRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('故障处理评分')">
            <el-rate
              v-model="returnForm.faultScore"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="!isEditReturn"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('处理结果备注')" prop="faultRemark">
            <el-input
              v-model="returnForm.faultRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('满意度评分')">
            <el-rate
              v-model="returnForm.attitudeScore"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="!isEditReturn"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('服务态度备注')" prop="attitudeRemark">
            <el-input
              v-model="returnForm.attitudeRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('维保工及时评分')">
            <el-rate
              v-model="returnForm.timelinessScore"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="!isEditReturn"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('及时性备注')" prop="timelinessRemark">
            <el-input
              v-model="returnForm.timelinessRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('保养记录评分')">
            <el-rate
              v-model="returnForm.mtScore"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="!isEditReturn"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('记录确认备注')" prop="mtRemark">
            <el-input
              v-model="returnForm.mtRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('配件供应评分')">
            <el-rate
              v-model="returnForm.spareScore"
              show-text
              :text-color="rateTextColor"
              :texts="rateTexts"
              :disabled="!isEditReturn"
            ></el-rate>
          </el-form-item>
          <el-form-item :label="$l('配件供应备注')" prop="spareRemark">
            <el-input
              v-model="returnForm.spareRemark"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('客户反馈')" prop="custReturn">
            <el-input
              v-model="returnForm.custReturn"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('公司反馈')" prop="compReturn">
            <el-input
              v-model="returnForm.compReturn"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('处理人')" prop="compReturnPerson">
            <el-input
              v-model="returnForm.compReturnPerson"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('联系电话')" prop="compReturnPersonTel">
            <el-input
              v-model="returnForm.compReturnPersonTel"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$l('评价联系人')" prop="evaluateContactPerson">
            <el-input
              v-model="returnForm.evaluateContactPerson"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$l('评价联系人电话')"
            prop="evaluateContactPersonTel"
          >
            <el-input
              v-model="returnForm.evaluateContactPersonTel"
              :disabled="!isEditReturn"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="viewReturnDialogVisible = false"
            >{{ $l("关闭") }}
          </el-button>
          <el-button
            round
            type="primary"
            @click="saveReturn"
            v-if="isEditReturn"
            >{{ $l("保存") }}
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
        :title="$l('困人图片')"
        width="700px"
        :visible.sync="trappedDialogVisible"
        class="trapped_image"
      >
        <el-image
          v-for="(trappedImage, index) in trappedImageList"
          :key="index"
          :src="trappedImage"
          :preview-src-list="trappedImageList"
        >
        </el-image>
      </el-dialog>
      <videoMonitor ref="video"></videoMonitor>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import breadcrumb from "@/components/breadcrumb.vue";
import attrCard from "@/components/attrCard.vue";
import videoMonitor from "@/components/videoMonitor.vue";
// import areaCascader from "@/components/areaCascader.vue";
import global from "@/mixins/global.js";
export default {
  name: "alarm",
  mixins: [global],
  components: {
    panel,
    breadcrumb,
    attrCard,
    videoMonitor,
    // areaCascader,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: {
        pageNum: 0,
        pageSize: 0,
        city: null,
        domainName: null,
        jobNum: null,
        buildingName: null,
        registerCode: null,
        elevatorType: null,
        processType: "-1",
        description: "",
        returnStatus: null,
        boxUp: null,
        finishStatus: null,
        startDate: "",
        endDate: "",
        dataPermissionList: [],
      },
      settingForm: {
        isEnable: true,
        isEnableSpeak: false,
        number: 2,
      },
      settingDialogVisible: false,
      alarmTimeRange: [],
      tableData: null,
      loading: false,
      sourceIdArr: [
        { value: 0, text: "MAS系统" },
        { value: 1, text: "安400热线派工" },
      ],
      processTypeArr: [
        { value: 0, text: "电梯自恢复" },
        { value: 1, text: "派工" },
      ],
      monitorStatusArr: [
        { value: 1, text: "正常监视" },
        { value: 0, text: "异常" },
      ],
      elevatorStatusArr: [
        { type: 1, text: "困人", value: 0 },
        { type: 2, text: "非困人", value: 0 },
        { type: 3, text: "派工记录", value: 0 },
        { type: 4, text: "预警记录", value: 0 },
      ],
      isSearch: true,
      returnForm: {
        serviceOrder: "",
        returnFinishDatetime: "",
        returnComplateDatetime: "",
        returnDesc: "",
        isReturnFinish: false,
        finishRemark: "",
        unreasonableDemands: false,
        unreasonableRemark: "",
        faultScore: 0,
        faultRemark: "",
        attitudeScore: 0,
        attitudeRemark: "",
        timelinessScore: 0,
        timelinessRemark: "",
        mtScore: 0,
        mtRemark: "",
        spareScore: 0,
        spareRemark: "",
        custReturn: "",
        compReturn: "",
        compReturnPerson: "",
        compReturnPersonTel: "",
        evaluateContactPerson: "",
        evaluateContactPersonTel: "",
      },
      returnFormRules: {
        returnFinishDatetime: [
          {
            min: 14,
            max: 30,
            message: this.$l("长度在 14 到 30 个字符"),
            trigger: "blur",
          },
        ],
        returnComplateDatetime: [
          {
            min: 14,
            max: 30,
            message: this.$l("长度在 14 到 30 个字符"),
            trigger: "blur",
          },
        ],
        returnDesc: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        finishRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        unreasonableRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        faultRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        attitudeRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        timelinessRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        mtRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        spareRemark: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        custReturn: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        compReturn: [
          {
            min: 1,
            max: 500,
            message: this.$l("长度在 1 到 500 个字符"),
            trigger: "blur",
          },
        ],
        compReturnPerson: [
          {
            min: 1,
            max: 50,
            message: this.$l("长度在 1 到 50 个字符"),
            trigger: "blur",
          },
        ],
        compReturnPersonTel: [
          {
            min: 8,
            max: 20,
            message: this.$l("长度在 8 到 20 个字符"),
            trigger: "blur",
          },
        ],
        evaluateContactPerson: [
          {
            min: 1,
            max: 50,
            message: this.$l("长度在 1 到 50 个字符"),
            trigger: "blur",
          },
        ],
        evaluateContactPersonTel: [
          {
            min: 8,
            max: 20,
            message: this.$l("长度在 8 到 20 个字符"),
            trigger: "blur",
          },
        ],
      },
      viewReturnDialogVisible: false,
      rateTextColor: "#ff9900",
      rateTexts: ["非常不满意", "不满意", "基本满意", "满意", "非常满意"],
      returnCallStatusArr: [
        "已分配",
        "已回访",
        "已答复",
        "已通知",
        "已完成",
        "已取消",
      ],
      // noReturnCallStatusArr: ["已放弃", "已释放", "EMES故障评价"],
      isEditReturn: false,
      fullLoading: false,
      faultDescList: [], //存放报警信息下拉框数据
      trappedDialogVisible: false, //查看困人图片对话框
      trappedImageList: [], //存放困人图片集合
      isStopTimer: false,
      level: 1, //默认显示第一级
      statisticType: null, //统计类型：1表示困人，2表示非困人，3表示派工记录，4表示预警记录
      rowData: null,
      tempTableData: null,
      tempTotalCount: 0,
      tempForm: null,
      tempElevatorStatusArr: null,
    };
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      if (this.level == 1) {
        this.initData(true);
      } else {
        this.initChildData(this.rowData, 0);
      }
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      if (this.level == 1) {
        this.initData(true);
      } else {
        this.initChildData(this.rowData, 0);
      }
    },
    handleMonitor(index, row) {
      if (row.isactive != 1) {
        this.$message.error("遥监设备断开，无法实时监视，请及时恢复。");
        return;
      }
      this.$router.push({
        path: "monitor",
        query: {
          row: row,
        },
      });
    },
    viewTrappedImage(row) {
      this.trappedImageList = [];
      this.fullLoading = true;
      this.$http
        .post(this.$apiConfig.get_trapped_image_url, {
          deviceType: row.deviceType, //摄像头类型
          deviceno: row.jobNum, //"21R151793",
          malfunctiondate: row.alarmDate, //"2023-05-20 10:39:31",
        })
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.trappedDialogVisible = true;
            this.trappedImageList = result.data;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(5);
          this.$sentry.captureException(error);
        });
    },
    playback(row) {
      row.playType = 2;
      row.pageInfo = "PC端-报警管理-视频回放";
      this.$refs.video.playVideo(2, row);
    },
    handleRefresh(index, row) {},
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    search() {
      this.pageConfig.currentPage = 1;
      if (this.level == 1) {
        this.initData();
      } else {
        this.initChildData(this.rowData, 0);
      }
    },
    showSetting() {
      this.settingDialogVisible = true;
      const enabled = localStorage.getItem(
        this.$store.state.user.username + "_alarm_tips_enabled"
      );
      const enableSpeak = localStorage.getItem(
        this.$store.state.user.username + "_alarm_tips_enableSpeak"
      );
      // const number = localStorage.getItem(this.$store.state.user.username + "_alarm_speak_play_number");
      if (enabled != null) {
        this.settingForm.isEnable = enabled == "0" ? false : true;
      }
      if (enableSpeak != null) {
        this.settingForm.isEnableSpeak = enableSpeak == "0" ? false : true;
      }
      // if(number){
      //   this.settingForm.number = parseInt(number);
      // }
    },
    settingAlarm() {
      const username = this.$store.state.user.username;
      const isOldEnable = localStorage.getItem(
        username + "_alarm_tips_enabled"
      );
      const isOldEnableAudio = localStorage.getItem(
        username + "_alarm_tips_enableSpeak"
      );
      if (!isOldEnable || this.settingForm.isEnable != parseInt(isOldEnable)) {
        localStorage.setItem(
          username + "_alarm_tips_enabled",
          this.settingForm.isEnable ? 1 : 0
        );
      }
      if (
        !isOldEnableAudio ||
        this.settingForm.isEnableSpeak != parseInt(isOldEnableAudio)
      ) {
        localStorage.setItem(
          username + "_alarm_tips_enableSpeak",
          this.settingForm.isEnableSpeak ? 1 : 0
        );
      }
      // localStorage.setItem(this.$store.state.user.username + "_alarm_speak_play_number", this.settingForm.number);
      if (!this.settingForm.isEnable) {
        this.$store.state.isStopAlarmTips = true;
      } else {
        if (!isOldEnable || isOldEnable == "0") {
          this.$store.state.isStopAlarmTips = false;
          this.$store.state.isCloseAlarmTips = true;
          this.alarmTips();
        }
      }
      // if(this.settingForm.isEnableSpeak){
      //   this.alarmAudioTips();
      // }else{
      //   this.$store.state.alarmAudio.pause();
      //   this.$store.state.alarmAudio.load();
      // }
      this.settingDialogVisible = false;
      this.message(0, "设置成功");
    },
    initData(isPaging) {
      this.isStopTimer = true;
      this.rowData = null;
      this.statisticType = null;
      this.level = 1;
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.isSearch = false;
      this.loading = true;
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      if (this.alarmTimeRange && this.alarmTimeRange.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.alarmTimeRange[0]
        );
        this.form.endDate = this.$common.formatDateTime(this.alarmTimeRange[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      if (!isPaging) {
        this.statisticsElevatorStatus();
      }
      this.$http
        .post(this.$apiConfig.group_search_alarm_url, this.form)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            this.tempTableData = JSON.stringify(this.tableData);
            this.tempTotalCount = result.data.total;
            this.tempForm = JSON.stringify(this.form);
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          }
          this.isSearch = true;
        })
        .catch((error) => {
          this.loading = false;
          this.isSearch = true;
          this.$sentry.captureException(error);
        });
    },
    initChildData(data, type) {
      this.level = 2;
      this.isSearch = false;
      this.loading = true;
      if (type) {
        if (typeof data == "number") {
          this.rowData = null;
          this.statisticType = data;
        } else {
          this.rowData = data;
          this.statisticType = null;
        }
        this.pageConfig.currentPage = 1;
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      if (this.alarmTimeRange && this.alarmTimeRange.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.alarmTimeRange[0]
        );
        this.form.endDate = this.$common.formatDateTime(this.alarmTimeRange[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      let params = {};
      if (this.rowData) {
        let city = this.rowData.city;
        let domainId = this.rowData.domainId;
        let domainName = this.rowData.domainName;
        this.form.domainId = domainId;
        this.form.city = city;
        this.form.domainName = domainName;
        for (const key in this.form) {
          params[key] = this.form[key];
        }
        if (domainId == null) {
          params.domainId = "-1";
          if (city == null) {
            params.city = "-1";
          }
          if (domainName == null) {
            params.domainName = "-1";
          }
        }
      } else {
        if (this.statisticType > 2) {
          this.form.processType = this.statisticType == 3 ? "1" : "0";
        } else {
          this.form.processType = "1";
          this.form.boxUp = this.statisticType == 1 ? "是" : "否";
        }
        for (const key in this.form) {
          params[key] = this.form[key];
        }
      }
      this.tableData = [];
      this.$http
        .post(this.$apiConfig.search_alarm_url, params)
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.$store.state.alarmMonitorStatusTimer &&
              this.$store.state.alarmMonitorStatusTimer != -1
            ) {
              this.openTimer();
            }
          }
          this.isSearch = true;
        })
        .catch((error) => {
          this.loading = false;
          this.isSearch = true;
          this.$sentry.captureException(error);
          if (
            !this.$store.state.alarmMonitorStatusTimer &&
            this.$store.state.alarmMonitorStatusTimer != -1
          ) {
            this.openTimer();
          }
        });
    },
    getCurrentSelect() {
      if (this.rowData) {
        return this.rowData.domainName
          ? this.rowData.domainName
          : "" + this.rowData.city
          ? this.rowData.city
          : "";
      } else {
        return this.$l(
          this.elevatorStatusArr
            .filter((item) => item.type == this.statisticType)
            .map((item) => item.text)[0]
        );
      }
    },
    statisticsElevatorStatus() {
      this.form.type = 1;
      this.elevatorStatusArr.forEach((item, index) => {
        item.value = 0;
      });
      let params = {};
      for (const key in this.form) {
        params[key] = this.form[key];
      }
      if (this.rowData) {
        let city = this.rowData.city;
        let domainId = this.rowData.domainId;
        let domainName = this.rowData.domainName;
        this.form.domainId = domainId;
        params.domainId = domainId;
        if (domainId == null) {
          params.domainId = "-1";
          if (city == null) {
            params.city = "-1";
          }
          if (domainName == null) {
            params.domainName = "-1";
          }
        }
      } else {
        delete this.form.domainId;
        delete params.domainId;
      }
      this.$http
        .post(this.$apiConfig.get_alarm_status_count_url, params)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            let data = result.data;
            this.elevatorStatusArr.map((o) => {
              if (o.type == 1) {
                o.value = data.count1;
              } else if (o.type == 2) {
                o.value = data.count2;
              } else if (o.type == 3) {
                o.value = data.count3;
              } else if (o.type == 4) {
                o.value = data.count4;
              }
            });
            this.tempElevatorStatusArr = JSON.stringify(this.elevatorStatusArr);
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    tableRowStyle({ row, rowIndex }) {
      if (row.boxUp && row.boxUp == "是") {
        return { background: "#fcedea" };
      }
      return {};
    },
    cityFormatter(row) {
      const city = row.city;
      if (!city) {
        return "";
      } else {
        return this.$l(city);
      }
    },
    boxUpFormatter(row) {
      if (row.boxUp) {
        return this.$l(row.boxUp);
      }
      return this.$l("否");
    },
    sourceFormatter(row) {
      for (let i = 0; i < this.sourceIdArr.length; i++) {
        if (this.sourceIdArr[i].value == row.sourceId) {
          return this.sourceIdArr[i].text;
        }
      }
      return "";
    },
    processWayFormatter(row) {
      for (let i = 0; i < this.processTypeArr.length; i++) {
        if (this.processTypeArr[i].value == row.processType) {
          return this.processTypeArr[i].text;
        }
      }
      return "";
    },
    rescueCompleteTimeFormatter(row) {
      if (row.processType == 0) {
        return "";
      }
      return row.rescueCompleteTime;
    },
    finishDateFormatter(row) {
      if (row.boxUp == "是") {
        return row.rescueTime ? row.rescueTime : row.finishDate;
      } else {
        return row.finishDate ? row.finishDate : row.rescueTime;
      }
    },
    elevatorBrandFormatter(row) {
      return this.$l(row.brand);
    },
    monitorStatusFormatter(row) {
      if (row.isactive == 1) {
        return this.$l(this.monitorStatusArr[0].text);
      }
      return this.$l(this.monitorStatusArr[1].text);
    },
    timerRefresh() {
      if (this.$store.state.alarmMonitorStatusTimer == -1) {
        return;
      }
      this.$store.state.alarmMonitorStatusTimer = window.setTimeout(() => {
        if (this.isStopTimer) {
          return;
        }
        if (!this.isSearch) {
          this.timerRefresh();
          return;
        }
        this.isSearch = false;
        this.loading = true;
        this.$http
          .post(this.$apiConfig.search_alarm_url, this.form)
          .then((response) => {
            this.loading = false;
            let data = response.data;
            if (data.code == 0) {
              this.pageConfig.total = data.data.total;
              this.tableData = data.data.result;
            }
            this.isSearch = true;
            this.timerRefresh();
          })
          .catch((error) => {
            this.loading = false;
            this.isSearch = true;
            this.timerRefresh();
            this.$sentry.captureException(error);
          });
      }, window.config.alarmMonitorStatusTimerInterval);
    },
    viewReturnCall(index, row) {
      this.viewReturnDialogVisible = true;
      if (!row.serviceOrder2) {
        this.fullLoading = true;
        this.$http
          .get(this.$apiConfig.get_return_call_url, {
            params: {
              serviceOrder: row.serviceOrder ? row.serviceOrder : "",
            },
          })
          .then((response) => {
            this.fullLoading = false;
            const result = response.data;
            if (result.code == 0) {
              this.initReturnCall(result.data);
              this.tableData[index].returnStatusName =
                result.data.returnStatusName;
            } else {
              this.message(result.code, result.msg);
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.message(1, "获取失败");
            this.$sentry.captureException(error);
          });
      } else {
        this.initReturnCall(row);
      }
    },
    initReturnCall(row) {
      for (let key in this.returnForm) {
        if (key.indexOf("Score") > 0) {
          this.returnForm[key] = row[key] ? parseInt(row[key]) : 0;
        } else {
          this.returnForm[key] = row[key];
        }
      }
      this.returnForm.isReturnFinish =
        !this.returnForm.isReturnFinish || this.returnForm.isReturnFinish == "0"
          ? false
          : true;
      this.returnForm.unreasonableDemands =
        !this.returnForm.unreasonableDemands ||
        this.returnForm.unreasonableDemands == "0"
          ? false
          : true;
      this.isEditReturn =
        this.returnCallStatusArr.filter((v) => v == row.returnStatusName)
          .length == 0;
    },
    saveReturn() {
      this.$refs.returnForm.validate((valid) => {
        if (valid) {
          this.fullLoading = true;
          this.$http
            .post(this.$apiConfig.save_return_call_url, this.returnForm)
            .then((response) => {
              this.fullLoading = false;
              const result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.viewReturnDialogVisible = false;
                this.initData();
              }
            })
            .catch((error) => {
              this.fullLoading = false;
              this.message(1, "保存失败");
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    returnCallStatusFormatter(row) {
      if (
        this.returnCallStatusArr.filter((v) => v == row.returnStatusName)
          .length == 1
      ) {
        return "已回访";
      } else {
        return "未回访";
      }
    },
    getFaultDescList() {
      if (this.$store.state.user.roleType == 1) {
        this.faultDescList = window.dataDictionary;
        return;
      }
      this.$http
        .get(
          this.$apiConfig.get_role_dictionary_permission_url +
            this.$store.state.user.roleId
        )
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.faultDescList = result.data;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    exportAlarm() {
      if (this.alarmTimeRange && this.alarmTimeRange.length == 2) {
        this.form.startDate = this.$common.formatDateTime(
          this.alarmTimeRange[0]
        );
        this.form.endDate = this.$common.formatDateTime(this.alarmTimeRange[1]);
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      this.fullLoading = true;
      let filename =
        "报警管理表_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url: this.$apiConfig.export_alarm_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    handleCloseTag() {
      this.isStopTimer = true;
      if (this.$store.state.alarmMonitorStatusTimer) {
        window.clearTimeout(this.$store.state.alarmMonitorStatusTimer);
        this.$store.state.alarmMonitorStatusTimer = null;
      }
      this.rowData = null;
      this.statisticType = null;
      this.level = 1;
      this.tableData = this.tempTableData
        ? JSON.parse(this.tempTableData)
        : this.tableData;
      this.pageConfig.total = this.tempTotalCount || 0;
      let form = this.tempForm
        ? JSON.parse(this.tempForm)
        : this.form;
      this.pageConfig.currentPage = form.pageNum;
      this.pageConfig.pageSize = form.pageSize;
      this.form = form;
      this.elevatorStatusArr = this.tempElevatorStatusArr
        ? JSON.parse(this.tempElevatorStatusArr)
        : this.elevatorStatusArr;
    },
    closeTimer() {
      if (
        this.$store.state.alarmMonitorStatusTimer &&
        this.$store.state.alarmMonitorStatusTimer != -1
      ) {
        window.clearTimeout(this.$store.state.alarmMonitorStatusTimer);
      }
      this.$store.state.alarmMonitorStatusTimer = -1;
    },
    openTimer() {
      if (this.level == 1) {
        return;
      }
      this.$store.state.alarmMonitorStatusTimer = window.setTimeout(() => {
        if (this.$store.state.alarmMonitorStatusTimer != -1) {
          this.$store.state.alarmMonitorStatusTimer = null;
          this.initChildData(this.rowData, 0);
        }
      }, window.config.alarmMonitorStatusTimerInterval);
    },
  },
  mounted() {
    this.getFaultDescList();
    this.$store.state.alarmMonitorStatusTimer = null;
    const query = this.$route.query;
    if (query && query.source == "index") {
      const date = query.date;
      this.alarmTimeRange = [
        new Date(date + " 00:00:00"),
        new Date(date + " 23:59:59"),
      ];
      this.form.processType = "1";
      if (query.atype == 1) {
        this.form.boxUp = "否";
      } else {
        this.form.boxUp = "是";
      }
      this.form.blockStatus = query.index;
    } else {
      this.alarmTimeRange = this.$common.getTimeRange(0);
    }
    if (this.loaded) {
      const type = this.$route.query.type;
      if (type) {
        this.form.blockType = type;
      }
      this.initData();
      // this.timerRefresh();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.closeTimer();
    next();
  },
  beforeDestroy() {
    this.closeTimer();
  },
  activated() {
    if (
      this.loaded &&
      (!this.$store.state.alarmMonitorStatusTimer ||
        this.$store.state.alarmMonitorStatusTimer == -1)
    ) {
      this.$store.state.alarmMonitorStatusTimer = null;
      this.openTimer();
    }
  },
};
</script>
<style lang="scss" scoped>
.alarm {
  .returnForm {
    .el-input {
      width: 400px;
    }
    .el-textarea {
      width: 400px;
    }
    .el-select {
      width: 400px;
    }
    /deep/ .el-textarea__inner {
      border-radius: 1em;
    }
    .el-rate {
      width: 400px;
      margin-top: 8px;
      margin-left: 20px;
    }
  }
  .boxup-row {
    background: #fcedea;
  }
  /deep/ .trapped_image {
    .el-dialog__body {
      min-height: 248px;
      max-height: 500px;
      overflow-y: auto;
      padding: 10px 10px;
    }
    .el-image {
      width: 200px;
      height: 200px;
      margin: 10px;
    }
  }
}
</style>
